// ABJ demo clone of src/components/washULivingWellCenter/living_well_center-3.js (LWC Success Stories, listed under Success Stories 6.0).
// Cloned 10/19/26 for TO-1810: lead-in doctor video removed, Living Well Center names removed (brand-neutral, TO-1823). Route: /abj-demo-lwc-success-stories
import React from "react";
import Container from "react-bootstrap/Container";
import { Nav } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { HashLink as Link } from "react-router-hash-link";

const LivingWellCenter3 = () => {
  return (
    <div>
      <div className="w-100 legosNewBuild livingWellCenterHeader">
        <section className="mb-0">
          {/* L6 Background image header bar */}
          <div className="lego l006 legoMargin5">
            <div
              className="backgroundImage"
              style={{
                backgroundImage:
                  "url(" +
                  "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/51bdd658df7cdfe452eafa7098542a93.jpeg" +
                  ")",
              }}
            >
              <div
                className="transparentBarTypeContainer abjHeader2e8dba"
                style={{
                  backgroundColor: "#8DCA64",
                }}
              >
                &nbsp;&nbsp;
              </div>
              <h2 className="l6SubheadWithBackground">
                Patient Success Stories
              </h2>
            </div>
          </div>
          {/* End L6 Background image header bar */}
        </section>
        <Container>
          <div className="w-100">
            <div className="col-12 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild livingWellCenterHeader">
                <section>
                  {/* L11A Image Max Width 400px */}
                  <div className="lego l011 legoMargin3">
                    <img
                      alt=""
                      className="imageW100 maxWidth600 noBorderRadius"
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/5044da583dcf347c03b9ed0d015df153.png"
                    />
                  </div>
                  {/* End L11A Image Max Width 400px */}

                  {/* L14B Paragraph With Bold Italic Spans */}
                  <div className="lego l00paragraph legoMargin1">
                    <p className="legoMargin1">
                      <span className="paragraph24px">David’s story. </span>
                    </p>
                    <p>
                      When David first came to us, he was
                      experiencing significant pain. Because of the pain, David
                      was limited in what he could do physically. His goal was
                      to travel and continue his photography. We could tell he
                      was ready to commit to an overhaul of his health. We
                      talked about how his back was driving the problem, but the
                      inflammation, diabetes, high blood pressure and inability
                      to move were significant contributors and really his
                      barriers to success.
                    </p>
                  </div>
                  {/* End L14B Paragraph With Bold Italic Spans */}
                  {/* L11A Image Max Width 400px */}
                  <div className="lego l011 legoMargin3">
                    <img
                      alt=""
                      className="imageW100 maxWidth600 noBorderRadius"
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/729aa453323f51a08b439967e41e6046.png"
                    />
                  </div>
                  {/* End L11A Image Max Width 400px */}

                  {/* L14B Paragraph With Bold Italic Spans */}
                  <div className="lego l00paragraph legoMargin1">
                    <p className="legoMargin1">
                      <span className="paragraph24px">Virginia’s story. </span>
                    </p>
                    <p>
                      Virginia’s journey with us is a
                      testament to the power of investing in your own health.
                      She encourages others not to be afraid to seek help and
                      emphasizes it's not just for those who are already sick,
                      but for anyone wanting to improve their quality of life,
                      "This is for healthy people, too!"
                    </p>
                  </div>
                  {/* End L14B Paragraph With Bold Italic Spans */}

                  {/* L11A Image Max Width 400px */}
                  <div className="lego l011 legoMargin3">
                    <img
                      alt=""
                      className="imageW100 maxWidth600 noBorderRadius"
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/820ed694a1f00ee5b753f65a8ae6cb8e.png"
                    />
                  </div>
                  {/* End L11A Image Max Width 400px */}

                  {/* L14B Paragraph With Bold Italic Spans */}
                  <div className="lego l00paragraph legoMargin1">
                    <p className="legoMargin1">
                      <span className="paragraph24px">Judy’s story. </span>
                    </p>
                    <p>
                      Judy had been managed (through her health issues) by
                      narcotics for over a decade and within three months of
                      starting this new lifestyle, she was off of her
                      narcotics.  People would say to her now that her faced
                      glowed, her eyes sparkled; it was just a major change in
                      you.
                    </p>
                  </div>
                  {/* End L14B Paragraph With Bold Italic Spans */}

                  <div className="col-12 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default LivingWellCenter3;
